import { makeStyles } from '@material-ui/core/styles';
import { magenta } from 'globals/colors';

export const useContainerStyles = makeStyles(() => ({
  root: {
    backgroundColor: magenta.V5,
    borderLeftColor: magenta.BRAND,
  },
}));

export const useStyles = makeStyles(() => ({
  iconClass: {
    position: 'absolute',
    top: '50%',
    left: 0,
    transform: 'translate(-50%, -50%)',
  },
}));
